var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFlagReportOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.243 7.603L11.237 2.04a.384.384 0 00-.452-.32l-2.235.413a.374.374 0 01-.435-.307 1.195 1.195 0 00-.47-.748 1.1 1.1 0 00-.858-.182l-4.719.878a.418.418 0 00-.248.157.398.398 0 00-.063.305L3.81 12.806c.04.184.199.317.376.317h.064l.012-.003a.385.385 0 00.257-.173.366.366 0 00.043-.289l-.89-4.592 4.248-.827a.364.364 0 01.278.06.389.389 0 01.157.246c.058.306.226.571.476.747.25.177.554.242.851.185l2.242-.414c.222-.056.358-.254.32-.46zM8.185 6.457A1.16 1.16 0 008 6.443c-.067 0-.13 0-.208.016l-4.262.827-.929-4.808 4.34-.801c.098-.02.193 0 .275.055.082.063.14.155.16.25l.81 4.475zm3.242.891l-1.87.35a.363.363 0 01-.278-.06.39.39 0 01-.157-.246l-.8-4.47c.132.021.263.019.382-.006l1.858-.35.867 4.782h-.002z",
    fill: "#F5F5F5"
  })));
}

export default SvgIconFlagReportOutline;